import { apiFetch } from "./client.js";
import type { EntityId, TextShortcut } from "../types.ts";

export type ShortcutPayload = {
  trigger: string;
  title: string;
  body: string;
  scope: "personal" | "global";
};

export async function fetchShortcuts(): Promise<TextShortcut[]> {
  const data = await apiFetch("/shortcuts");
  return Array.isArray(data) ? data : [];
}

export async function saveShortcut(payload: ShortcutPayload): Promise<TextShortcut> {
  return await apiFetch("/shortcuts", {
    method: "POST",
    body: JSON.stringify(payload),
  }) as TextShortcut;
}

export async function deleteShortcut(id: EntityId): Promise<void> {
  await apiFetch(`/shortcuts/${encodeURIComponent(String(id))}`, { method: "DELETE" });
}
